<template>
  <div
    class="py-5 px-3 rounded-md mx-2"
    style="max-width: 100%; margin: 0 auto"
  >
    <h1 class="fs-3 fw-bold ms-3 text-decoration-underline">
      {{ $t("Terms of use") }}
    </h1>
    <h2 class="fs-4 fw-semibold ms-3">{{ $t("Introduction") }}</h2>
    <div class="text-md text-secondary mt-3 ms-3" style="line-height: 1.75">
      {{
        $t("Welcome to Mars, a premier destination for online gaming enthusiasts. Our platform offers a diverse range of HTML5 games accessible from both desktop and mobile devices. This document, the Terms of Use, outlines the rules and guidelines for using our website and services. By accessing Mars you agree to these terms and abide by all applicable laws and regulations. If you do not agree with any part of these terms, please refrain from using our site. Our Terms of Use are designed to ensure a fair and enjoyable experience for all our users.")
      }}

      <div class="mt-3">
        <p class="fw-semibold">{{ $t("1. Acceptance of Terms") }}</p>
        <p>
          {{
            $t("By subscribing to our services, you agree to these Terms of Use and any amendments made over time.")
          }}
        </p>
        <p>
          {{
            $t("These terms may be updated periodically, and your continued use of the service signifies acceptance of the updated terms.")
          }}
        </p>

        <p class="fw-semibold">{{ $t("2. Access and Use") }}</p>
        <p>
          {{ $t("2.1 You must be at least 5 years old to use our services.") }}
        </p>
        <p>
          {{ $t("Our services are for personal, non-commercial use only.") }}
        </p>

        <p class="fw-semibold">{{ $t("Subscription and Payments") }}</p>
        <p>{{ $t("3.1 Access to games requires a paid subscription.") }}</p>
        <p>
          {{
            $t("3.2 Billing occurs on a [monthly/weekly/daily] basis and is non-refundable.")
          }}
        </p>
        <p>
          {{
            $t("3.3 Subscription can be canceled at any time, but no refunds will be provided for unused portions of the billing period.")
          }}
        </p>

        <div class="ms-4">
          <p class="fw-semibold">{{ $t("4. User Conduct") }}</p>
          <p>
            {{
              $t("4.1 You agree not to use the service for any unlawful purpose.")
            }}
          </p>
          <p>
            {{
              $t("4.2 You will not attempt to hack, destabilize, or adapt the website or its games.")
            }}
          </p>
          <p>
            {{
              $t("4.3 Respect other users; harassment or bullying will not be tolerated.")
            }}
          </p>
        </div>

        <div class="ms-4">
          <p class="fw-semibold">{{ $t("5. Intellectual Property.") }}</p>
          <p>
            {{
              $t("5.1 All games, content, and related intellectual property are owned by Enthalpy Technologies or its licensors.")
            }}
          </p>
          <p>
            {{
              $t("5.2 No content from the website may be copied, reproduced, or distributed without explicit permission.")
            }}
          </p>
        </div>

        <div class="ms-4">
          <p class="fw-semibold">{{ $t("6. Privacy") }}</p>
          <p>
            {{
              $t("6.1 Your privacy is important to us. Please review our Privacy Policy to understand how we collect and use your information.")
            }}
          </p>
        </div>

        <div class="ms-4">
          <p class="fw-semibold">{{ $t("7. Disclaimer of Warranties") }}</p>
          <p>
            {{
              $t("7.1 Our services are provided 'as is' without warranties of any kind, either express or implied.")
            }}
          </p>
        </div>

        <div class="ms-4">
          <p class="fw-semibold">{{ $t("8. Limitation of Liability") }}</p>
          <p>
            {{
              $t("8.1 Mars will not be liable for any indirect, incidental, or punitive damages arising from the use of our service.")
            }}
          </p>
        </div>

        <div class="ms-4">
          <p class="fw-semibold">{{ $t("9. Governing Law") }}</p>
          <p>{{ $t("9.1 These terms are governed by the laws of UAE.") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "TermsView",
};

</script>
